(() => {
  const root = document.documentElement;
  root.classList.remove('no-js');
  root.classList.add('js');

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-disclosure]');
    if (!trigger) return;

    const panel = document.getElementById(trigger.getAttribute('aria-controls'));
    if (!panel) return;

    const isOpen = trigger.getAttribute('aria-expanded') === 'true';
    trigger.setAttribute('aria-expanded', String(!isOpen));
    panel.hidden = isOpen;
  });
})();
